
const messages = {
    // branding
    'branding.name': 'WatchESPN',
    // meta
    'meta.keywords': 'spn, espn3, espn 3, espnplay, espn play, partidos, eventos, programas, shows, en vivo, tv online, ' +
    'en directo, ver online, on demand, pc, computadora, computador, m&oacute;vil, celular, smartphone, iphone, android, ' +
    'tablet, ipad, abierto de australia, australian open, x games, nba, liga de espa&ntilde;a, liga bbva, futbol de Espa&ntilde;a, ' +
    'ncaa, seria a italia, premier league, champions league, liga de campeones, UEFA, 6 naciones rugby',
    'meta.title.home': 'WatchESPN: Mira en vivo futbol, tenis, rugby, y muchos más deportes, de forma online a través de tu computadora tablet o móvil',
    'meta.description.home': 'Ingresa a ESPN Play desde tu PC, Tablet y M&oacute;vil para ver online los mejores partidos, ' +
    'eventos y programas deportivos en vivo y on demand.',
    'meta.title.schedule': 'Schedule: Live, Upcoming, Replays - WatchESPN',
    'meta.description.schedule': 'Get live, upcoming, and replay schedule information for your favorite sports and shows ' +
    'across every ESPN network on WatchESPN.',
    'meta.title.features': 'Featured Videos - WatchESPN',
    'meta.description.features': 'Watch featured news clips, game highlights, and special ESPN programming on WatchESPN.',
    'meta.title.collection': '{name} - WatchESPN',
    'meta.description.collection': 'Watch videos from the {name} collection on WatchESPN.',
    'meta.title.player': '{name} - WatchESPN',
    'meta.description.player': 'Watch the {name} video on WatchESPN.',
    'meta.title.activate': 'Activate - WatchESPN',
    'meta.description.activate': 'Activate your device',
    // schedule
    'schedule.header': 'Programar',
    'schedule.live': 'Vive Ahora',
    'schedule.upcoming': 'Próximo',
    'schedule.replay': 'Repetición',
    'schedule.allSports': 'Todos los deportes',
    'schedule.allNetworks': 'Todas las redes',
    'schedule.replay.all': 'Todas',
    'schedule.replay.today': 'Hoy',
    'schedule.replay.last7Days': 'Los últimos 7 días',
    'schedule.replay.last14Days': 'Últimos 14 días',
    'schedule.replay.last30Days': 'Últimos 30 días',
    // schedule module
    'schedule.module.header.live': 'Top Live',
    'schedule.module.header.upcoming': 'Upcoming',
    // search
    'search.placeholder': 'Encuentra tu equipo, evento o espectáculo...',
    'search.results.message': 'Buscar resultados para {query}',
    // player
    'player.error.defaultMessage': 'This network is not included in your current television subscription. Please contact your provider to upgrade.',
    'player.error.unexpectedMessage': 'An unexpected error occurred during authorization. Please refresh the page to try again.',
    // provider dialog
    'search.filter.placeholder': 'Buscar...',
    'provider.dialog.title': 'Elegir Proveedor',
    'provider.dialog.subtitle': 'Todos los Proveedores (A-Z):',
    'provider.dialog.subtitle.tier1': 'Elegir Proveedor:',
    'provider.dialog.description': 'ESPN\'s live TV networks are available for {noCost} ' +
    'to consumers of the providers listed below. Need help? Check {link} or call {call}.',
    'provider.dialog.description.noCost': 'no additional cost',
    'provider.dialog.faq.link': 'http://www.espn.com/watchespn/faq',
    'provider.dialog.faq.label': 'FAQs',
    'provider.dialog.call': '888-549-ESPN',
    // sign out
    'signout.message': '¿Quieres salir de tu cuenta de {providerName}',
    'signout.label': 'Desconectar',
    // misc
    'live': 'EN VIVO'
};

export default messages;



// WEBPACK FOOTER //
// ./app/lib/i18n/es.js